import {Component, OnInit, ViewChild} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {basicTransition} from "../../../libs/basicTransition";
import {IAppStatic, IUser} from "../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {AppService, StoreSelectorsService} from "../../services";
import {FormBuilder} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {DEFAULT_RESELLER_ID, isMediaSignageInc, isNullOrUndefOrEmpty, popupWindow} from "../../common";
import {Compbaser} from "../../components/compbaser";
import {TutorialsComponent} from "../../components/tutorials/tutorials.component";
import {ToastrService} from "ngx-toastr";
import {Lib} from "../../../libs/Lib";
import {MatTabGroup} from "@angular/material/tabs";
import {timeout} from "../../decorators/timeout";
import {ChatCustomerComponent} from "../../components/chat/chat-customer/chat-customer.component";
import {faRightFromBracket} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    animations: [basicTransition],
    styleUrls: ['./help.component.scss']
})
export class HelpComponent extends Compbaser implements OnInit {
    ready = false;
    titleAlert = 'This field is required';
    post: any = '';
    showHeader;
    showBack;
    showToggle = true;
    autoPlayVideoId;
    appSettings: IAppStatic;
    showTutorials = true;
    toggleIcon = true;
    isFullFeatures: boolean;
    resellerId;
    videoUrlWhiteLabel;
    videoUrlWhiteLink;
    private m_user: IUser;


    readonly faRightFromBracket = faRightFromBracket;

    // @ViewChild('.iframe') iframe: ElementRef;
    @ViewChild('tutorials', {static: false}) tutorialsComponent: TutorialsComponent;
    @ViewChild('tabGroup') tabGroup: MatTabGroup;
    @ViewChild('chatApp') chatApp: ChatCustomerComponent;

    constructor(private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private translocoService: TranslocoService,
                private appService: AppService,
                private toastr: ToastrService,
                private _http: HttpClient,
                private storeSelector: StoreSelectorsService) {
        super();
        this.resellerId = DEFAULT_RESELLER_ID;
        const v = this.route.data['value'];
        this.showHeader = v && v.showHeader == false ? v.false : true;
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((val) => {
                this.isFullFeatures = val;
            })
        );
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                })
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                const videoId = routeParams.get('video_id');
                if (videoId) this.autoPlayVideoId = videoId;

            })
        );
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
    }

    ngOnInit() {
        this.checkWhiteLabeledVideo();
        this.cod(
            this.route.queryParams.subscribe((routeParams) => {
                // const tutorials = routeParams?.tutorials;
                const back = routeParams?.back;
                const chat = routeParams?.chat;
                // const tutorials = routeParams?.tutorials;
                const contact = routeParams?.contact;
                const chatReseller = routeParams?.chatreseller;
                if (back) this.showBack = true;
                if (chatReseller) {
                    this.showBack = true;
                    try {
                        this.resellerId = Lib.RC4Decrypt(chatReseller);
                    } catch (e) {
                        this.resellerId = DEFAULT_RESELLER_ID;
                    }
                    this.switchTab(1);
                    return;
                }
                // if (tutorials) {
                //     this.switchTab(0);
                //     return;
                // }
                if (chat) {
                    this.switchTab(1);
                    return;
                }
                if (contact) {
                    this.switchTab(2);
                    return;
                }
                // if (isHostLocal()) {
                //     this.switchTab(1);
                // }
            })
        );
    }

    @timeout(1000)
    switchTab(v) {
        if (!this.tabGroup) return;
        this.tabGroup.selectedIndex = v;
    }

    // onLiveHelp() {
    //     Lib.openLiveChat(false, this.m_user, this.appSettings, this.isFullFeatures);
    // }

    // onLocalChanged() {
    //     this.showTutorials = false;
    //     setTimeout(() => this.showTutorials = true);
    // }

    onSelectedTabChange(e) {
        if (e.tab.textLabel === 'chat') {
            this.chatApp.scrollToBottom();
        }
        this.showToggle = this.tabGroup && this.tabGroup.selectedIndex === 0;
    }

    toggleVideoPane() {
        if (this.tutorialsComponent) {
            this.toggleIcon = !this.toggleIcon;
            this.tutorialsComponent.toggleVideoList();
        }
    }

    // setChangeValidate() {
    //     this.formGroup.get('validate').valueChanges.subscribe(
    //         (validate) => {
    //             if (validate === '1') {
    //                 this.formGroup.get('name').setValidators([Validators.required, Validators.minLength(3)]);
    //                 this.titleAlert = "You need to specify at least 3 characters";
    //             } else {
    //                 this.formGroup.get('name').setValidators(Validators.required);
    //             }
    //             this.formGroup.get('name').updateValueAndValidity();
    //         }
    //     );
    // }

    private checkWhiteLabeledVideo() {
        if (!this?.m_user?.enterprise) return;
        this.videoUrlWhiteLabel = this?.m_user?.customStudio?.Studio?.MainMenu[0]?.CommandGroup[0]?.Command[1]?.$?.label?.toLowerCase();
        this.videoUrlWhiteLink = this?.m_user?.customStudio?.Studio?.MainMenu[0]?.CommandGroup[0]?.Command[1]?.$?.href?.toLowerCase();
        if (isNullOrUndefOrEmpty(this.videoUrlWhiteLabel) || isNullOrUndefOrEmpty(this.videoUrlWhiteLink)) return;
        if (isMediaSignageInc(this.videoUrlWhiteLink)) {
            return;
        }
        this.showTutorials = false;

    }

    onWhiteLabelVideo() {
        popupWindow({url: this.videoUrlWhiteLink, title: this.videoUrlWhiteLabel, h: 200, w: 300});
    }

    checkInUseEmail(control) {
        // future support to check server for email contact
        const db = ['jack@torchwood.com'];
        return new Observable(observer => {
            setTimeout(() => {
                const result = (db.indexOf(control.value) !== -1) ? {'alreadyInUse': true} : null;
                observer.next(result);
                observer.complete();
            }, 1000);
        });
    }

}
